import React from 'react'
import { SubstatusAliasQuery } from '../vulnerability-status/substatus-alias-query'
import { Substatus } from '../vulnerability-status/status'
import { SubstatusAliasSettings } from '.'

export interface ChildProps {
  readonly substatusAliasSettings?: NonNullable<SubstatusAliasSettings>
  readonly refetchSubstatusAliasSettings: () => Promise<any>
}
export interface Props {
  readonly organizationUuid: string
  readonly children: (props: NonNullable<ChildProps>) => React.ReactNode
}

export function SubstatusAliasSettingsLoader({
  organizationUuid,
  children
}: Props) {
  return (
    <SubstatusAliasQuery
      organizationUuid={organizationUuid}
      substatus={Substatus.OTHER.name}
    >
      {({ substatusAlias, refetch: refetchSubstatusAliasSettings }) => {
        if (
          (typeof substatusAlias !== 'undefined' || !!substatusAlias) &&
          substatusAlias.alias
        ) {
          const substatusAliasSettings = {
            aliasEnabled: true,
            alias: substatusAlias.alias
          }
          return children({
            substatusAliasSettings,
            refetchSubstatusAliasSettings
          })
        }

        const substatusAliasSettings = {
          aliasEnabled: false,
          alias: ''
        }
        return children({
          substatusAliasSettings,
          refetchSubstatusAliasSettings
        })
      }}
    </SubstatusAliasQuery>
  )
}
